import {
    GET_FILES, GET_FILES_LOADING,
    UPLOAD_FILES_ERROR,
    UPLOAD_FILES_LOADING,
    UPLOAD_FILES_RESULT
} from '../types';

const fileReducer = (state, action) => {

    switch (action.type) {
        case GET_FILES_LOADING: {
            return {
                ...state,
                getFilesLoading: action.payload
            }
        }
        case GET_FILES:
            return {
                ...state,
                getFilesLoading: false,
                uploadedFiles: action.payload
            }

        case UPLOAD_FILES_LOADING:
            return {
                ...state,
                uploadFilesLoading: action.payload
            }

        case UPLOAD_FILES_RESULT:
            return {
                ...state,
                uploadFilesResult: action.payload,
                uploadFilesError: null,
                uploadFilesLoading: false
            }

        case UPLOAD_FILES_ERROR:
            return {
                ...state,
                uploadFilesError: action.payload,
                uploadFilesResult: null,
                uploadFilesLoading: false
            }

        default:
            return state;
    }
}

export default fileReducer;